import { px2rem } from "@moim/common";
import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: ${px2rem(20)} ${px2rem(16)};
`;

export const ItemBox = styled.div`
  width: 100%;
  padding: ${px2rem(8)};

  & + & {
    margin-top: ${px2rem(12)};
    border-top: 1px solid ${props => props.theme.colorV2.colorSet.grey200};
  }
`;

export const Button = styled.button`
  margin-left: ${px2rem(12)};
  min-width: ${px2rem(60)};
  height: ${px2rem(28)};
  padding: 0 ${px2rem(8)};
  border-radius: ${px2rem(8)};

  transition: background-color 160ms ease-in-out;
  background-color: ${props => props.theme.color.blue};

  :disabled {
    background-color: ${props => props.theme.colorV2.colorSet.grey100};
    cursor: not-allowed;
  }
`;
